import { IonButtons, IonContent, IonHeader, IonMenuButton, IonPage, IonTitle, IonToolbar,
   IonButton,
   IonList,
   IonItem,
   IonLabel,
   IonIcon,
   IonToast,
   IonModal,
   IonTextarea,
   IonInput,
   IonRadioGroup,
   IonRadio,
   IonListHeader,
   IonItemDivider,
   IonDatetime,
   IonToggle,
   IonText,
   IonLoading,
   IonRow,
   IonCol,
   IonGrid,
   IonItemOptions,
   IonItemOption,
   IonItemSliding,
   IonAvatar
} from '@ionic/react';
import React, { useState, useEffect, useRef } from 'react';
import { useHistory } from 'react-router-dom';
import { chevronDown, chevronForward, cloudUpload, documentText, time, checkmarkCircle, refreshOutline, chevronDownOutline} from 'ionicons/icons';
import { format, parseISO } from 'date-fns';
import './Task.css';
import OpenMenuButton from "../../../components/OpenMenuButton";
import ImageWithAuth from "../../../components/ImageWithAuth";
import { useParams } from 'react-router';
import ServerService from '../../../services/Server';
import Util from '../../../services/Util';
import { Environment } from "../../../data/Environment";
import { useForm, Controller } from 'react-hook-form';
import ListBox from '../../../components/ListBox';
import NumberInput from '../../../components/NumberInput';
import { GeoType } from '../../../services/Geo';

// import { isExportAssignment, isVariableStatement } from 'typescript';
// import { setUncaughtExceptionCaptureCallback } from 'process';
const JSON5 = require("json5")

type TaskParams = {
  id:string, 
  type:string, 
  dummy:string
}

const Task: React.FC = () => {

  const { control, handleSubmit, formState:{errors}, formState, clearErrors} = useForm({
    mode:'onSubmit'
  });

const {id, type, dummy} = useParams<TaskParams>();
const history = useHistory();

const [showError, setShowError] = useState(null);
const [errMsg, setErrMsg] = useState("");
const [errColor, setErrColor] = useState("danger");
const [showLoading, setShowLoading] = useState(false);
const [showMsg, setShowMsg] = useState(false);
const [showWarning, setShowWarning] = useState(false);
const [showModal, setShowModal] = useState(false);
const [btnDis, setBtnDis] = useState(false);
const [reason, setReason] = useState(null);
const [act, setAct] = useState(null);
const [dtls, setDtls] = useState([]);
const [expandDtls, setExpandDtls] = useState(true);
const [docs, setDocs] = useState([]);
const [expandDocs, setExpandDocs] = useState(true);
const [atts, setAtts] = useState([]);
const [expandAtts, setExpandAtts] = useState(true);
const [cmts, setCmts] = useState([]);
const [expandCmts, setExpandCmts] = useState(true);
const [btns, setBtns] = useState([]);
const [info, setInfo] = useState({
  title:"",
  desc:"",
  memoId:"",
  sepColor:"",
  dtlLbl:"",
  inpLbl:"",
  docLbl:"",
  attLbl:"",
  cmtLbl:"",
  saveLocation:false
});
const fileInput = useRef(null);

const [panels, setPanels] = useState({});
const [inps, setInps] = useState({});

const [needReason, setNeedReason] = useState(false);

const [listBoxState, setShowListBox] = useState({ showPicker:false, title:'', inp:null, id:null, inps:null, onChange:null})
const [mandaGrps, setMandaGrps] = useState({})
const [chkManda,setChkManda] = useState(false)

const server = new ServerService();
var state = server.state;

const util = new Util();

type FormType = { doc: any, att: any, cmt:any, info:any, dtl:any, btn:any, inps:any};

var goBack = false;

const okBtn = 
{
  side: 'end',
  icon: checkmarkCircle,
  text: 'OK',
  role: 'cancel',
  handler: () => {
    setShowLoading(false);
    setBtnDis(false);
    setShowError(false);
    setErrColor("danger");
    console.log("OK goBack:"+goBack);
    if(goBack) {
      setShowMsg(false);
      goBack = false;
      history.push("/page/home/mytasks")
    }
  }
}

const refreshBtn = {
  text:'Refresh',
  icon: refreshOutline,
  handler: () => {
    setShowLoading(false);
    setBtnDis(false);
    setShowError(false);
    setErrColor("danger");
    window.location.reload();
  }
}

const [errBtns, setErrBtns] = useState([okBtn,refreshBtn]);

const doFetchDtls = async function(state:any) {
  console.log("doFetchDtls()");

  var timeout = true;
  setTimeout(()=>{
    if (timeout) {
      console.log("err timeout");
      setErrMsg("Please check Internet Connection!");
      setErrColor("dark");
      setErrBtns([okBtn, refreshBtn])
      setShowError(true);
    }
  },4000)

  const data = {taskId:id}
  const res = await fetch(server.getFullUrl("memo/taskEditMb/get", data),server.getRequest())
  .then(res => res.json()
  .then(async res => {
        timeout = false;

        if (!res.success) {
          console.log("err 4");
          setErrMsg(res.message);
          setErrBtns([okBtn])
          if (res.message.indexOf("is COMPLETED")>=0) {
            console.log("go back 2");
            goBack = true;
          }
          setShowError(true);
          return {};
        }

        if (res.data.id===0) {
          console.log("err 3");

          setErrMsg("No Data");
          setErrBtns([okBtn, refreshBtn])
          setShowError(true);
          return {};
        }

        var tmpMandaGrps : {[k:string]:any} = {}
        var inps2: any = {}
        var inps = res.data.inp;
        var pnls:any = {"000":{display_name:res.data.info?.inpLbl, expand:true, inps:[]}};

        const a = await inps.map(async (inp:any,i:any) => {

          if (inp.display_type === "P") {
            const name = inp.field_name;
            inp.expand = true;
            inp.inps = [];
            pnls[name] = inp;
          }
          else
          if (inp.display_type !== "B") {
            const param = JSON5.parse("{"+inp.spc_param+"}");
            inp.valueFrom = param.valueFrom;
    
            if (inp.display_type === "C" && inp.value === "now") {
              inp.value = (new Date()).toISOString()
            } else
            if (inp.display_type === "X" && param.mandaGrp) {
              if(!tmpMandaGrps[param.mandaGrp]) {
                tmpMandaGrps[param.mandaGrp] = {member:[],msg:"Please check at least one check box"}
              }
              tmpMandaGrps[param.mandaGrp].member.push(inp.field_name)
              if (param.mandaMsg) {
                tmpMandaGrps[param.mandaGrp].msg = param.mandaMsg
              }
            }
  
            inps2[inp.field_name] = inp;
          }

          // if (inp.display_type !== "P" && inp.display_type !== "B") {
          //   setInps(prevState => ({...prevState, [inp.field_name]:inp.value ? inp.value : ""}));
          // }

          // if (inp.display_type === "R" || inp.display_type === "L") {
          //   inps[i].opts = await listOptions(inp);

          //   return "";
          // } else
          // if (inp.display_type === "P") {
          //     const name = inp.field_name;
          //     inp.expand = true;
          //     inp.inps = [];
          //     pnls[name] = inp;
          // }
        })

        Object.keys(tmpMandaGrps).map((key: any) => {
          console.log("mandaGrp.key:"+key)
        })
        setMandaGrps(tmpMandaGrps)
      
        Promise.all(a).then(() => {
          inps.map((inp:any,i:any) => {
            if (inp.display_type !== "P" && inp.display_type !== "H") {
              var pname = "000";
              if (inp.parent_name) {
                pname = inp.parent_name;
              }
              const panel = util.getKeyValue(pname)(pnls);
              panel.inps.push(inp);
              pnls[pname] = panel;
            }
          });

          setPanels(pnls)
        });

        return {info:res.data.info, dtl:res.data.dtl, doc:res.data.doc, att:res.data.att, btn:res.data.btn, cmt:res.data.cmt, inps:inps2}
  },
  (error) => {
      timeout = false;
      console.log("err 2");
      setErrMsg(error);
      setErrBtns([okBtn])
      setShowError(true);
  })
  )
  .catch(e => {
    timeout = false;
    console.log("err 1");
    setErrMsg("Please check Internet Connection!");
    setErrColor("dark");
    setErrBtns([okBtn, refreshBtn])
    setShowError(true);
  })

  const resAll = {...res} as FormType
  return resAll;
}

// const getOriJson = function(str:string) {
//   return str.replace(/\=\=\=\=/g, '<br/>').replace(/\|\|\|\|/g, '"');
// }

const getLocation = () => {

  server.getLocation(null).then((l: GeoType) => {
    const loc = l.lat+","+l.lon;

    console.log("=======")
    console.log("loc:"+loc)
    console.log("=======")

    doSubmit(loc)
  });
}

const doSubmit = (loc:any) => {

  var inpMap : {[k:string]:any} = {}

  Object.keys(inps).map((key: any) => {
    const inp = util.getKeyValue(key)(inps)
    inpMap[inp.field_name] = inp.value ? inp.value : ""
  });

  var params: any = {
    "a":act,
    "t":id,
    "ck":state.customerKey,
    "n":type,
    "i":JSON.stringify(inpMap)
  }

  if (loc) {
    params.loc = loc
    params.locDtl = window.navigator.platform+","+window.navigator.userAgent
  }

  if (reason) {
    params.r = reason;
  }

  server.state = {...server.state}

  fetch(server.getPrefixUrl()+"memo/taskEditMb/submit",server.postRequest(params,{}))
    .then(res => {
      if (res.ok) {
        res.json()
        .then(
          (result) => {
            //console.log(result);
            setShowLoading(false);
            if (result.success) {
              setShowMsg(true);
            } else {
              console.log("doAction err 5");
              setChkManda(true)

              if (result.message.startsWith("|BG_ERR|")) {
                console.log("   "+result.message.substring("|BG_ERR|".length));
                setErrMsg(result.message.substring("|BG_ERR|".length));
              } else {
                setErrMsg(result.message);
              }

              setErrBtns([okBtn])
              if (result.message.indexOf("the task doesnt exist")>=0) {
                console.log("go back");
                goBack = true;
              }
              setShowError(true);
            }
          },
          // Note: it's important to handle errors here
          // instead of a catch() block so that we don't swallow
          // exceptions from actual bugs in components.
          (error) => {
            console.log("doAction err 4");
            setShowLoading(false);
            setErrMsg(error);
            setErrBtns([okBtn])
            setShowError(true);
          }
      )
      } else {
        // for(const a in res) {
        //   console.log("-"+a);
        // }
        setShowLoading(false);
        console.log("status:"+res.status);
        if (res.status === 500) {
          res.text().then(
            (value) => {
              console.log("value:"+value);
              const pos = value.indexOf("|BG_ERR|");
              if (pos>=0) {
                console.log("doAction err 3");
                const pos2 = value.indexOf("</td>", pos+8);
                if (pos2>=0) {
                  const msg = value.substring(pos+8, pos2);
                  console.log("errMsg:"+msg);
                  setErrMsg(msg);
                  setErrBtns([okBtn])
                  setShowError(true);
                }
              } else{
                console.log("doAction err 2");
                console.log("value:"+value);
                setErrMsg("Error:Contact Administrator");
                setErrBtns([okBtn])
                setShowError(true);
              }
            }
          )
        }
      }
    })
    .catch(e => {
      console.log("doAction err 1");
      setShowLoading(false);
      setErrMsg("Please check Account Settings or Internet Connection!");
      setErrBtns([okBtn])
      setShowError(true);  
    })
}

const doAction = function(reason:any) {
  setShowLoading(true);

  if (info.saveLocation) {
    getLocation();
  } else {
    doSubmit(null);
  }
  
}

const upload = (file:any) => {

  setShowLoading(true);

  const formData = new FormData();
  formData.append("id",info.memoId);
  formData.append("tid",id);
  formData.append(file.name, file);

  fetch(server.getPrefixUrl()+"memo/taskEditMb/upload", server.uploadRequest(formData)
  ).then(
    response => response.json() // if the response is a JSON object
  ).then(res => {
    setShowLoading(false);
    if (res.success) {
      setAtts([...atts, {
        nodeRef:res.data[0].nodeRef,
        name:res.data[0].name,
        action:res.data[0].action
      }]);
    } else {
      console.log(res.message);
    }
  }).catch(
    error => {
      setShowLoading(false);
      console.log(error) // Handle the error response object
    }
  );
}

const deleteFile = (nodeRef:any) => {

  setShowLoading(true);

  const params:any = {
    "doc":nodeRef,
    "tid":id
  }

  fetch(server.getPrefixUrl()+"memo/file/delete",server.postRequest(params,{})).then(
    response => response.json()
  ).then(res => {
    setShowLoading(false);
    if (res.success) {
      setAtts(
        atts.filter(item => item.nodeRef !== nodeRef)
      )
    } else {
      console.log(res.message);
    }
  }).catch(
    error => {
      setShowLoading(false);
      console.log(error) // Handle the error response object
    }
  );
}

const handleTrigger = async (inp:any,inps:any) => {
  if (inp.before_script) {
    eval(inp.before_script)
  }

  if (inp.trigger_field) {

    for(var a in inps) {
      console.log("-"+a+":"+inps[a])
    }

    const tgrField = inp.trigger_field.split(",");
    tgrField.forEach((tgrName:string) => {
      const prefix = tgrName.substring(0,2)
      if (prefix !== "H_" && prefix !=="F_") {
        tgrName = "F_"+tgrName
      }
      console.log("  tgr:"+tgrName+" , "+inp.field_name);
      const tgr:any = util.getKeyValue(tgrName)(inps);
      if (tgr) {
        doHandleTrigger(tgr, inps);
      } else {
        console.log("    Not Found:");
        alert("Trigger Not Found : "+tgrName);
      }
    })
  }

  if (inp.after_script) {
    eval(inp.after_script)
  }
}

const doHandleTrigger = async (tgr:any,inps:any) => {
  console.log("doHandleTrigger():srcUrl:"+tgr.src_url+", srcParam:"+tgr.src_param)

  if (tgr.src_url) {
      //console.log(tgr.src_url+":"+tgr.src_param);
        if(tgr.display_type === "R" || tgr.display_type === "L") {
      
          tgr.opts = await server.listOptions(tgr,id,inps)
          if (!tgr.value && tgr.opts.length===1) {
            console.log("  after listOption():"+tgr.field_name)
            console.log("     opts.length==1")
            tgr.value = tgr.opts[0].id
  
            handleTrigger(tgr, inps)
          }
  
          for (var o in tgr.opts) {
            if ((tgr.value === tgr.opts[o].id) || (parseInt(tgr.value) === parseInt(tgr.opts[o].id))) {
              tgr.valueLabel = tgr.opts[o].name
              break;
            }
          }
  
          return tgr.opts;
          //setInps(prevState => ({...prevState}));

        } else {
          var srcUrl = tgr.src_url;
						
          if (srcUrl && srcUrl.substring(0,2) === "${") {
            var pos2 = srcUrl.indexOf("}");
            var srcName = srcUrl.substring(2,pos2);
            
            var pfx = srcName.substring(0,2);
            if ((pfx !== "H_") && (pfx !== "F_")) {
              srcName = "F_" + srcName;
            }

            var f = util.getKeyValue(srcName.trim())(inps);
            var fv = "";
            if (!f) {
              alert("Field Not Found : "+srcName.trim());
            }
            else {
              fv = f.value;
            }							
          
            tgr.value = fv;
          
          } else {
            const srcUrl = server.finalSrcUrl(tgr.src_url);
            const params = tgr.src_param.split(",");
            const finalParam = server.parseParams(params,id,inps)
            await fetch(server.getFullUrl("srcUrl/"+srcUrl, finalParam),server.getRequest())
              .then(res => {
              if (res.ok) {
                  return res.json()
                  .then((result) => {
                       if (result.success) {
                         var pfx = tgr.field_name.substring(0,2);
                         //console.log(result.data)
                         var dataArray = result.data;
                         //console.log(dataArray.length)
                         if (dataArray.length > 0) {
                              //console.log("pfx:"+pfx+",savetofield:"+tgr.save_to_field)
                             if (pfx === "H_" && (tgr.save_to_field === "approval_matrix_id")) {
                               if (dataArray.length > 1) {
                                 // show error
                                 //BG.Dlg.error(null, MODULE_MEMO, {msg:"Found "+dataArray.length+" Approval Matrixes! Please contact administrator"});
                                 console.log("Found "+dataArray.length+" Approval Matrixes! Please contact administrator");
                                 tgr.value = null;
                                 //me.getBtnApprovalMatrix().hide();
                                 return;
                               }
                               
                               tgr.value = dataArray[0].id;
                              //  me.getBtnApprovalMatrix().show();
                              //  me.getBtnApprovalMatrix().fid = f.value;
                              // loadDefaultUsers(tgr.value);

                               handleTrigger(tgr, inps)

                             } else if (tgr.display_type==="D") {
                                // var hid = parent.down("field[name="+field.name+"_h]");
                                // if (dataArray[0].id) {
                                //   field.bgData.value = dataArray[0].id;
                                //   field.bgData.v = dataArray[0].id;
                                //   field.show();
                                  
                                //   hid.setValue(dataArray[0].id);
                                // }
                                // else {
                                //   field.hide();
                                //   hid.setValue(null);
                                // }
                                
                             } else {
                                var isDirty = tgr.value !== dataArray[0].id
                                if (isDirty) {
                                  tgr.value = dataArray[0].id;
                                  handleTrigger(tgr, inps)
                                }
                             }
                         } else {
                            tgr.value = null;
                            if (pfx === "H_" && (tgr.save_to_field === "approval_matrix_id")) {
                              // me.getBtnApprovalMatrix().hide();
                              // me.getBtnApprovalMatrix().fid = null;
                            }
                         }
                       }
                  })
              }});

          }
        }
    }
}

const callSrcUrl = async (inp:any, inps:any) => {

  console.log("callSrcUrl():srcUrl:"+inp.src_url+", srcParam:"+inp.src_param)

  if (inp.src_url) {
    if (inp.display_type === "R" || inp.display_type === "L") {
      
        inp.opts = await server.listOptions(inp,id,inps)

        for (var o in inp.opts) {
          if ((inp.value === inp.opts[o].id) || (parseInt(inp.value) === parseInt(inp.opts[o].id))) {
            inp.valueLabel = inp.opts[o].name
            break;
          }
        }

        return inp.opts;
    }

  }
}

const fetchDtls = async function() {
    console.log("fetchDtls()");
    setAtts([]);
    setInfo({
      title:"",
      desc:"",
      memoId:"",
      sepColor:"",
      dtlLbl:"",
      inpLbl:"",
      docLbl:"",
      attLbl:"",
      cmtLbl:"",
      saveLocation:false
    });
    setDtls([]);
    setDocs([]);
    setBtns([]);
    setCmts([]);

    setPanels({});
    setInps({});

    const res = await doFetchDtls(state);

    setAtts(res.att)
    setInfo(res.info)
    setDtls(res.dtl)
    setDocs(res.doc)
    setBtns(res.btn)
    setCmts(res.cmt)
    setInps(res.inps)

  /*
    process inps
  */
  if (res.inps) {
    console.log("   inps.length:"+Object.keys(res.inps).length)
    const a = Object.keys(res.inps).map(async (key: any) => {
      const inp = util.getKeyValue(key)(res.inps)
      console.log("  -" + inp.field_name+":"+inp.value);

      /*
        load list box or radio options
      */
      if (inp.src_url) {
        return callSrcUrl(inp, res.inps)
      }
    })

    Promise.all(a).then(() => {
      setPanels(prevState => ({...prevState}))
    })
  }
}

useEffect(() => {
  console.log("Task : useEffect(dummy)");
  if (!state.base64ticket) {
      server.login(async () => {
        state = server.state;
        fetchDtls();
      });
  } else {
    fetchDtls();
  }

}, [dummy])

useEffect(() => {
  //console.log("Task : useEffect()");
  /*
  const s = document.createElement('script');
  s.type = 'text/javascript';
  s.async = true;
  s.innerHTML = "setTimeout(function() {document.getElementById('uploadBtn').onchange = function () {document.getElementById('uploadFile').value = this.value}}, 5000)";
  document.body.appendChild(s);
  */
},[])

useEffect(() => {

  Object.keys(formState).map((key: any) => {
    const v = util.getKeyValue(key)(formState)
    console.log(" -"+key+":"+v)
  })

  //console.log("isSubmitting:"+formState.isSubmitting+", isSuceess:"+formState.isSubmitSuccessful+", isDirty:"+formState.isDirty+", isSubmitted:"+formState.isSubmitted+", isValidating:"+formState.isValidating+", isValid:"+formState.isValid)
    if(formState.isSubmitting && !formState.isSubmitSuccessful) {
        setErrMsg("Invalid Input Value!")
        setErrBtns([okBtn])
        setShowError(true)
    } else
    if (!formState.isSubmitting && formState.isSubmitSuccessful) {
      if (!chkManda) {
        setShowError(false)
      }
    }
},[formState])

const validateForm = () => {
  console.log("validateForm")
 
  var result = true;

  if (Object.keys(mandaGrps).map.length > 0) {
    Object.keys(mandaGrps).map((key: any) => {
      const grp = util.getKeyValue(key)(mandaGrps)
      console.log("  -" + key + ":"+grp.member+":"+grp.msg);

      if (result) {
        if (grp.member.length > 0) {

          var checked = false
          grp.member.forEach((mem: any) => {
            const inp = util.getKeyValue(mem)(inps)
            console.log("   inp.name:"+inp.field_name+", checked:"+checked+", inp:"+inp.value)
            if (!checked && inp.value) {
              checked = true
            }
          })

          if (!checked) {
            result = checked
            setChkManda(true)
            setErrMsg(grp.msg)
            setErrBtns([okBtn])
            setShowError(true)
          }
        }

      }

    })
  }

  console.log("result:"+result)
  return result
}

const action = function(action:any, reason:any, validate:boolean) {
  //form.dispatchEvent(new Event("submit", {cancelable: true, bubbles: true}));
  setAct(action)
  setNeedReason(reason)
  setReason("")

  if (validate) {
    if (validateForm()) {
      var form = document.forms[0];
      for(var a in document.forms) {
          console.log("form:"+a+":"+document.forms[a].id)
          if (document.forms[a].id === "frmTask") {
            form = document.forms[a]
          }
      }
      form.dispatchEvent(new Event("submit", {cancelable: true, bubbles: true}));
    }
  } else {
    setShowModal(true)
  }
}


const onSubmit = (data:any) => {
  // console.log("onSubmit()")
  // for(var a in data) {
  //   console.log("- data["+a+"]:"+data[a])
  // }
  //sendForApproval()

  //setAct(action)
  //setNeedReason(reason)
  // setReason("")
   setShowModal(true)

  return false
}

const mergeTextField = (inp:any,ctrlRules:any) => {
  var field
  if (inp.field_type==="I" || inp.field_type==="F") {
    const df = inp.display_format?.split("|")
    field = (
      <><IonLabel position="floating">{inp.display_name}
      {inp.is_mandatory ?
      <span dangerouslySetInnerHTML={{__html: '<font color="red"> *</font>'}}></span>
      : ""
      }
      </IonLabel>
        <Controller
          name={inp.field_name}
          control={control}
          rules={ctrlRules}
          defaultValue={inp.value}
          render={({field:{onChange, onBlur, value}}) => (
            <NumberInput
              prefix={df.length>3 ? df[3] : undefined}
              suffix={df.length>4 ? df[4] : undefined}
              thousandSeparator={df.length>1 ? df[1] : ","}
              fixedDecimalScale={df.length>2 && parseInt(df[2])>0}
              decimalSeparator={df.length>2 && parseInt(df[2])>0 ? "." : undefined}
              decimalScale={df.length>2 ? df[2] : undefined}
              allowNegative={df.length>0 && df[0]}
              readonly={false}
              onIonChange={
                (r: any) => {
                    // for(var a in r) {
                    //   console.log("=r["+a+"]:"+r[a])
                    // }
                    inp.value = r.value
                    onChange(r)
//                                        inp.value = r.formattedValue;
                    //setTabs(prevState => ([...prevState]))
                    handleTrigger(inp, inps)
                }
              }
              value={inp.value}
            />
          )}
        />
        {
          errors[inp.field_name] && <div className="error">Please Enter {inp.display_name}</div>
        }
      </>
    )
  } else {
  field = (
    <><IonLabel position="floating">{inp.display_name}
      {inp.is_mandatory ?
      <span dangerouslySetInnerHTML={{__html: '<font color="red"> *</font>'}}></span>
      : ""
      }
      </IonLabel>
      <Controller
        name={inp.field_name}
        control={control}
        rules={ctrlRules}
        defaultValue={inp.value}
        render={({field:{onChange, onBlur, value}}) => (
          <IonInput 
            name={inp.field_name}
            onIonChange={onChange}
            onIonBlur={onBlur}
            value={inp.value}
            maxlength={inp.field_length ? inp.field_length : undefined}
            onIonInput={(e:any) => {
              inp.value = e.target.value;
              setInps(prevState => ({...prevState, [e.target.name]:inp}))
              handleTrigger(inp, inps)
            }}
          />
        )}
      />
      {
        errors[inp.field_name] && <div className="error">Please Enter {inp.display_name}</div>
      }
   </>
  )
  }
  return field
}

const mergeTextArea = (inp:any,param:any,ctrlRules:any) => {
  const style = {"minHeight":(inp.display_height ? inp.display_height : 150)+"px"}
  var field = (
    <><IonLabel position="floating">{inp.display_name}{inp.is_mandatory ?
      <span dangerouslySetInnerHTML={{__html: '<font color="red"> *</font>'}}></span>
      : ""
      }
      </IonLabel>
        <Controller
          name={inp.field_name}
          control={control}
          rules={ctrlRules}
          defaultValue={inp.value}
          render={({field:{onChange, onBlur, value}}) => (
            <IonTextarea style={style} maxlength={inp.field_length ? inp.field_length : undefined}
            rows={param.rows ? param.rows : undefined} cols={param.cols ? param.cols : undefined}
            onIonChange={(e:any) => {
              inp.value = e.target.value ? e.target.value : "";
              setInps(prevState => ({...prevState, [e.target.name]:inp}))
              handleTrigger(inp, inps)
            }}
              name={inp.field_name}
              onChange={onChange}
              onIonBlur={onBlur}
              value={inp.value}
            />
          )}
        />
    {
      errors[inp.field_name] && <div className="error">Please Enter {inp.display_name}</div>
    }
    </>
  )
  return field
}

const mergeListBox = (panel:any,inp:any,param:any,ctrlRules:any,i:any) => {
  var field = (
    <Controller
    name={inp.field_name}
    control={control}
    rules={ctrlRules}
    defaultValue={inp.value}
    render={({field:{onChange, onBlur, value}}) => (
    <>
    <IonItem key={i} className="itemAccordion" hidden={!panel.expand} onClick={(e) => {
          setShowListBox({showPicker:true, title:inp.display_name, inp:inp, id:id, inps:inps, onChange:onChange})
          e.stopPropagation()
      }}>
          <IonLabel position="floating">{inp.display_name}
          {inp.is_mandatory ?
          <span dangerouslySetInnerHTML={{__html: '<font color="red"> *</font>'}}></span>
          : ""
          }
          </IonLabel>
          <IonInput className="listbox-input" readonly
              name={inp.field_name}
              onIonChange={e => {
                //console.log("listbox onIonChange("+e+") "+inp.field_name+" "+e.target+","+inp.valueLabel+","+inp.value+","+value)
                if (inp.value) {
                  //console.log("  onChange")
                  onChange(e)
                  //setInps(prevState => ({...prevState, [inp.field_name]:inp}))
                  handleTrigger(inp, inps)
                }
              }}
              value={inp.valueLabel ? inp.valueLabel : undefined}
              onIonBlur={onBlur}
              onFocus={() => {clearErrors(inp.field_name)}}
          ></IonInput>
          <IonIcon className="listbox-button" slot="end" icon={chevronDownOutline}></IonIcon>
    </IonItem>
    {
      errors[inp.field_name] && <IonItem key={inp.field_name+"_err"}><IonLabel color="danger">{param.errorText ? param.errorText : "Please Select Value"}</IonLabel></IonItem>
    }
    </>
    )}
    />
  )

  return field
}

const mergeCheckBox = (inp:any) => {
  var field = (
    <>
    <IonToggle checked={inp.value===true ? inp.value : (inp.value === "" ? false : inp.value)} name={inp.field_name} 
        onIonChange={(e:any) => {
          inp.value = e.detail.checked;
          setInps(prevState => ({...prevState, [e.target.name]:inp}))
          handleTrigger(inp, inps)
        }}/>
    <IonLabel>{inp.display_name}</IonLabel>
    </>
  )

  return field
}

const mergeRadio = (panel:any,inp:any,ctrlRules:any,i:any) => {
  var options:{}[] = [];
  //console.log("render inp.opts:"+inp.opts);
  inp.opts.map((d:any,inx:any) => {
      options.push(
        <IonItem lines="none" key={inx}>
        <IonLabel>{d.name}</IonLabel>
        <IonRadio slot="start" value={d.id}></IonRadio>
        </IonItem>
      );
  })

  var field = (
    <>
    <Controller
        name={inp.field_name}
        control={control}
        rules={ctrlRules}
        render={({field:{onChange, onBlur, value}}) => (
          <IonRadioGroup key={i} allowEmptySelection={!inp.is_mandatory} className="itemAccordion" hidden={!panel.expand}
            onIonChange={(e:any) => {
              inp.value = e.detail.value;
              setInps(prevState => ({...prevState, [e.target.name]:inp}))
              handleTrigger(inp, inps)
            }}
            name={inp.field_name}
            onChange={onChange}
            onBlur={onBlur}
            value={inp.value}
            >
            <>
            <IonListHeader lines="none" className="center">
            <IonLabel color={inp.is_mandatory ? "danger" : "dark"}>{inp.display_name+(inp.is_mandatory ? " *" : "")}</IonLabel>
            </IonListHeader>
            {options}
            <IonItemDivider></IonItemDivider>
            </>
          </IonRadioGroup>
        )}
  />
  {
    errors[inp.field_name] && <div className="error">Please Select {inp.display_name}</div>
  }
  </>
  )
  return field
}

const mergeCalendar = (inp:any,ctrlRules:any) => {
  var field = (
    <>
    <IonLabel>{inp.display_name}
    {inp.is_mandatory ?
    <span dangerouslySetInnerHTML={{__html: '<font color="red"> *</font>'}}></span>
    : ""
    }
    </IonLabel>
    {/* <IonDatetime displayFormat={inp.display_format} value={inp.value}
      name={inp.field_name} onIonChange={(e:any) => {
          inp.value = e.detail.value;
          setInps(prevState => ({...prevState, [e.target.name]:e.detail.value}));
        }
      }> 
    </IonDatetime> */}
    <Controller
          name={inp.field_name}
          control={control}
          rules={ctrlRules}
          render={({field:{onChange, onBlur, value}}) => (
            <>
            { inp.formattedValue !== undefined ? <IonText>{ inp.formattedValue }</IonText> : <IonText class="placeholder">Select a date</IonText>}
            <IonDatetime
                onIonChange={(e:any) => {
                  inp.value = e.detail.value;
                  inp.formattedValue = format(parseISO(inp.value!), inp.display_format)
                  setInps(prevState => ({...prevState, [e.target.name]:inp}));
                  handleTrigger(inp, inps)
                }}
                name={inp.field_name}
                onChange={onChange}
                onIonBlur={onBlur}
                value={inp.value}
            > 
            </IonDatetime>
            </>
          )}
    />
    {
      errors[inp.field_name] && <div className="error">Please Enter {inp.display_name}</div>
    }
    </>
  )
  return field
}

const mergeLabel = (inp:any) => {
  var field = (
    <IonText>{inp.display_name}</IonText>
  )

  return field
}

var inputs: {}[];

  return (
    <IonPage>
      <IonHeader>
        <IonToolbar>
          <IonButtons slot="start">
            <IonMenuButton />
            <OpenMenuButton />
          </IonButtons>
          <IonTitle>{server.task.name} : {info?.desc}</IonTitle>
        </IonToolbar>
      </IonHeader>

      <IonContent>
        <IonHeader collapse="condense">
          <IonToolbar>
            <IonTitle>{server.task.name} : {info?.desc}</IonTitle>
          </IonToolbar>
        </IonHeader>

        <IonItem color={info?.sepColor} className="itemStable">
            <div style={{ display: 'flex', gap:'4px' }}>
            <IonLabel color="primary"><strong>Workflow ID : </strong></IonLabel><IonLabel>{info?.memoId}</IonLabel>
            </div>
        </IonItem>

        <IonList>
          <IonItem color={info?.sepColor} className="itemStable" onClick={(e) => setExpandDtls(!expandDtls)}>
            <IonIcon icon={expandDtls ? chevronDown : chevronForward}/>
            <IonLabel>{info?.dtlLbl}</IonLabel>
          </IonItem>
          <IonGrid>
            {dtls?.map((dtl,i) => {
              if (expandDtls) {
                return(
                  <IonItem key={i} className="itemStable ion-no-padding">
                    <IonRow className="ion-align-items-start">
                      <IonCol size="auto"><IonLabel className="ion-text-wrap" color="primary"><strong>{dtl.label} : </strong></IonLabel></IonCol>
                      <IonCol><IonLabel className="ion-text-wrap">{dtl.value}</IonLabel></IonCol>
                    </IonRow>
                  </IonItem>
                )
              }
            })}
          </IonGrid>
        </IonList>

        <form onSubmit={handleSubmit(onSubmit)} id="frmTask">
        
        {Object.keys(panels).map((key:any) => {
            const panel = util.getKeyValue(key)(panels)
            console.log("panel:"+panel+","+key);
            if (panel.inps.length>0) {
            return (
              <IonList key={key}>
                <IonItem key={key+"_000"} color={info?.sepColor} className="itemStable" onClick={(e) => {panel.expand = !panel.expand;setPanels(prevState => ({...prevState, [key]:panel}))}}>
                  <IonIcon icon={panel.expand ? chevronDown : chevronForward}/>
                  <IonLabel>{panel.display_name}</IonLabel>
                </IonItem>

            {panel.inps?.map((inp:any,i:any) => {
                inputs = []

                const param = JSON5.parse("{"+inp.spc_param+"}");

                var ctrlRules = {required:inp.is_mandatory}

                var field;
                if (inp.display_type === "T") {
                  field = mergeTextField(inp, ctrlRules)
                } else 
                if (inp.display_type === "A") {
                  field = mergeTextArea(inp,param,ctrlRules)
                } else 
                if (inp.display_type === "L") {
                  field = mergeListBox(panel,inp,param,ctrlRules,i)
                } else 
                if (inp.display_type === "X") {
                  field = mergeCheckBox(inp)
                } else 
                if (inp.display_type === "R") {
                  field = mergeRadio(panel,inp,ctrlRules,i)
                } else 
                if (inp.display_type === "C") {
                  field = mergeCalendar(inp,ctrlRules)
                } else 
                if (inp.display_type === "B") {
                  field = mergeLabel(inp)
                } else {
                  field = (
                      <IonLabel>
                        Unknown Display Type : "{inp.display_type}"
                      </IonLabel>
                  )
                }

                if (inp.display_type !== "R" && inp.display_type !== "L") {
                  inputs.push(
                      <IonItem key={i} className="itemAccordion" hidden={!panel.expand}>
                        {field}
                      </IonItem>
                  )
                } else {
                  if (field) {
                    inputs.push(field)
                  }
                }

                return inputs
            })}
            
            </IonList>
            )
          }
        })}
        </form>

        <IonList>
          <IonItem color={info?.sepColor} className="itemStable" onClick={(e) => setExpandDocs(!expandDocs)}>
            <IonIcon icon={expandDocs ? chevronDown : chevronForward}/>
            <IonLabel>{info?.docLbl}</IonLabel>
          </IonItem>
          <IonGrid>
            {docs?.map((doc,i) => {
              if (expandDocs) {
                return(
                  <IonItem key={i} className="itemAccordion ion-no-padding" hidden={!expandDocs} onClick={(e)=>{
                    //window.open("https://"+state.host+":"+state.port+Environment.API_PREFIX+"node/"+cid+"/content/"+doc.name2+"?c=force&noCache="+new Date()+"&a=false&alf_ticket="+state.ticket);
                    //window.open(server.getViewDocUrl(doc.id,doc.name))
                    let url = (!server.task.v) || (server.task.v < '000411') ? server.getOldViewDocUrl(doc.id, doc.name) : server.getViewDocUrl(doc.id, doc.name);
                    window.open(url);
                  }}>
                  <IonRow className="ion-align-items-start">
                  <IonCol size="auto"><IonIcon style={{width:22,height:22}} icon={documentText}/></IonCol>
                  <IonCol>
                  <IonLabel className="ion-text-wrap">{doc.name}</IonLabel>
                  </IonCol>
                  </IonRow>
                  </IonItem>
                )
              }
            })}
         </IonGrid>
        </IonList>

        <IonList>
          <IonItem color={info?.sepColor} className="itemStable" onClick={(e) => {
              setExpandAtts(!expandAtts)
            }}>
            <IonIcon icon={expandAtts ? chevronDown : chevronForward}/>
            <IonLabel>{info?.attLbl}</IonLabel>
            <input
              ref={fileInput}
              hidden
              type="file"
              accept="*/*"
              onChange={e => {
                //console.log("onChange");
                upload(e.target.files[0]);
              }}
              onClick={(e) => {
                //console.log('onClick');
                e.stopPropagation()
              }}
            />
            <IonButton
              className="btnUpload"
              color="primary"
              size="default"
              onClick={(e) => {
                // @ts-ignore
                fileInput?.current?.click();
                // setBackgroundOption(BackgroundOptionType.Gradient);
                //console.log('stopProp');
                e.stopPropagation()
              }}>
              Upload
            </IonButton>
          </IonItem>
          <IonGrid>
            {atts?.map((att,i) => {
                if (expandAtts) {
                  return(
                    <IonItemSliding key={i}>

                    <IonItem key={i} className="itemAccordion ion-no-padding" onClick={(e)=>{
  //                    window.open("https://"+state.host+":"+state.port+Environment.API_PREFIX+"node/"+cid+"/content/"+att.name+"?c=force&noCache="+new Date()+"&a=false&alf_ticket="+state.ticket);
  
                        let url = (!server.task.v) || (server.task.v < '000411') ? server.getOldViewDocUrl(att.nodeRef, att.name) : server.getViewDocUrl(att.nodeRef, att.name);
                        //let url = util.getVersion()>=server.task.v ? server.getViewDocUrl(att.nodeRef, att.name) : server.getOldViewDocUrl(att.nodeRef, att.name);
                        window.open(url);
                    }}>
                    <IonRow className="ion-align-items-start">
                    <IonCol size="auto"><IonIcon style={{width:22,height:22}} icon={att.path ? cloudUpload : documentText}/></IonCol>
                    <IonCol>
                      <IonLabel className="ion-text-wrap">{att.name}</IonLabel>
                    </IonCol>
                    </IonRow>
                    </IonItem>

                    {att.action.indexOf("D")>=0 ? 
                    <IonItemOptions side="end">
                    <IonItemOption color="danger" onClick={(e) => {
                      deleteFile(att.nodeRef)
                    }}>Remove</IonItemOption>
                    </IonItemOptions>
                    : ""}

                    </IonItemSliding>
                  )
                }
            })}
          </IonGrid>
        </IonList>

        <IonList>
          <IonItem color={info?.sepColor} className="itemStable" onClick={(e) => setExpandCmts(!expandCmts)}>
            <IonIcon icon={expandCmts ? chevronDown : chevronForward}/>
            <IonLabel>{info?.cmtLbl}</IonLabel>
          </IonItem>
          <IonGrid>
            {cmts?.map((cmt,i) => {
                //console.log("userRef:"+cmt.userRef+","+util.getNodeRefStr(cmt.userRef))
                if (expandCmts) {
                  return(                 
                    <IonItem key={i} className="itemAccordion ion-no-padding">
                    <IonRow className="ion-align-items-start">
                    <IonCol size="auto">
                      <IonAvatar>
                      {
                          cmt.avatar ?
                          (<ImageWithAuth src={server.getApiUrl()+"node/"+util.getNodeRefStr(cmt.avatar)+"/content/thumbnail/avatar?c=force"}/>)
                          :
                          cmt.user.substring(0,1).match("^[a-zA-Z0-9]*$") ?
                          (<ImageWithAuth src={server.getPrefixUrl()+"util/letterIcon?letter="+cmt.user.substring(0,1).toUpperCase()}/>)
                          :
                          (<img src="/assets/img/contact-icon.png" />)
                      }
                      </IonAvatar></IonCol>
                    <IonCol>
                      <IonLabel className="ion-text-wrap">{cmt.user} : {cmt.actionLabel} : {cmt.task}<br/>
                        <p>{cmt.time} {cmt.comment}</p>
                      </IonLabel>
                    </IonCol>
                    </IonRow>
                    </IonItem>
                  )
                }
            })}
          </IonGrid>
        </IonList>

        <div className="center">
        {btns?.map((btn,i) => {
            const param = JSON.parse("{"+btn.spc_param+"}");
            return(
              <IonButton disabled={btnDis} className="btnForm" key={i} color={btn.color ? (server.color[btn.color] ? server.color[btn.color] : btn.color) : "primary"} 
              onClick={(e) => {
                  setBtnDis(true);
                  action(btn.name, btn.reason, !(param.validate && param.validate === "0"))
              }}>
                  <IonIcon icon={btn.icon ? server.icon[btn.icon] : checkmarkCircle}/>
                  {btn.label}
              </IonButton>
            )
        })}
        </div>

      <IonToast
        isOpen={showError}
        message={errMsg}
        position="middle"
        buttons={errBtns}
        color={errColor}
        onDidDismiss={() => {
          setChkManda(false)
          setShowLoading(false)
          setShowError(false)
        }}
      />
      <IonLoading 
        isOpen={showLoading}
        onDidDismiss={() => setShowLoading(false)}
        message={'Please wait...'}
      />
      <IonToast
        isOpen={showMsg}
        onDidDismiss={() => {
          setShowLoading(false);
          setShowMsg(false);
          setBtnDis(false);
          history.replace("/page/home/mytasks", {})
        }}
        message="Success"
        position="middle"
        color="success"
        duration={2000}
      />
      <IonToast
        isOpen={showWarning}
        onDidDismiss={() => setShowWarning(false)}
        message="Reason needed!"
        position="middle"
        color="warning"
        duration={2000}
      />
      <IonModal isOpen={showModal}>
        <IonList>
          <IonItem>
            <IonLabel position="fixed"><b>Description:</b></IonLabel>
            <IonInput type="text" value={info?.memoId + " - " + info?.desc} readonly></IonInput>
          </IonItem>
          <IonItem>
            <IonLabel position="fixed"><b>Action:</b></IonLabel>
            <IonInput type="text" value={act} readonly></IonInput>
          </IonItem>
          <IonItem>
            <IonTextarea required={true} rows={10} placeholder="Reason..." value={reason} onIonInput={e => setReason(e.detail.value)}/>
          </IonItem>
        </IonList>
        <div className="center">
        <IonButton className="btnForm" color="danger" size="default" onClick={() => {
            setShowModal(false)
            setBtnDis(false)
          }}>Cancel</IonButton>
        <IonButton className="btnForm" color="success" size="default" onClick={() => {
            if (needReason) {
              if (!reason) {
                setShowWarning(true);
              } else {
                setShowModal(false);
                doAction(reason)
              }
            } else {
              setShowModal(false);
              doAction(reason ? reason : "")
            }
          }}>Submit</IonButton>
        <br/><br/>
        </div>
      </IonModal>

      <ListBox state={{showPicker:listBoxState.showPicker, title:listBoxState.title, inp:listBoxState.inp, id:id, inps:inps, onChange:listBoxState.onChange}} 
        onDismiss={() => {
          setShowListBox({showPicker:false, title:'', inp:null, id:null, inps:null, onChange:null})
        }}
        onSelect={async (item:any,inp:any) => {
          inp.value = item.id
          inp.valueLabel = item.name

          await handleTrigger(inp, inps)

          console.log("onSelect:"+inp.field_name+":trigger:"+inp.trigger_field)
          //handleTrigger(inp, inps)
          //inp.value = e.target.value

          //setPanels(prevState => ({...prevState}))
        }}
      />

      </IonContent>
    </IonPage>
  );
}

export default Task;
